import CryptoJS from 'crypto-js';


export async function loadEnvironmentConfig() {
      try {
        const response = await fetch('/config/config.json');
        if (!response) {
          throw new Error("Failed to load config.json");
        }
        const { data } = await response.json();

    const secretKey = CryptoJS.enc.Utf8.parse("a1b2c3d4e5f6g7h8"); 
    const iv = CryptoJS.enc.Utf8.parse("1a2b3c4d5e6f7g8h"); 

    const decrypted = CryptoJS.AES.decrypt(data, secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

    if (!decryptedText) {
      throw new Error("Decryption failed. Possibly wrong key or IV.");
    }

    const config = JSON.parse(decryptedText);
    window.env = config;

      } catch (error) {
        window.env = {}; 
      }
    }